import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { UploadableFormAttachment, UploadableFormAttachmentInput } from './uploadable-form-attachment.model';


export const loadUploadableFormAttachments = createAction(
  '[UploadableFormAttachment/API] Load UploadableFormAttachments',
  props<{ uploadableFormAttachments: UploadableFormAttachment[] }>()
);

export const addUploadableFormAttachment = createAction(
  '[UploadableFormAttachment/API] Add UploadableFormAttachment',
  props<{ uploadableFormAttachment: UploadableFormAttachment }>()
);

export const upsertUploadableFormAttachment = createAction(
  '[UploadableFormAttachment/API] Upsert UploadableFormAttachment',
  props<{ uploadableFormAttachment: UploadableFormAttachment }>()
);

export const addUploadableFormAttachments = createAction(
  '[UploadableFormAttachment/API] Add UploadableFormAttachments',
  props<{ uploadableFormAttachments: UploadableFormAttachment[] }>()
);

export const upsertUploadableFormAttachments = createAction(
  '[UploadableFormAttachment/API] Upsert UploadableFormAttachments',
  props<{ uploadableFormAttachments: UploadableFormAttachment[] }>()
);

export const updateUploadableFormAttachment = createAction(
  '[UploadableFormAttachment/API] Update UploadableFormAttachment',
  props<{ uploadableFormAttachment: Update<UploadableFormAttachment> }>()
);

export const updateUploadableFormAttachments = createAction(
  '[UploadableFormAttachment/API] Update UploadableFormAttachments',
  props<{ uploadableFormAttachments: Update<UploadableFormAttachment>[] }>()
);

export const deleteUploadableFormAttachment = createAction(
  '[UploadableFormAttachment/API] Delete UploadableFormAttachment',
  props<{ id: string }>()
);

export const deleteUploadableFormAttachments = createAction(
  '[UploadableFormAttachment/API] Delete UploadableFormAttachments',
  props<{ ids: string[] }>()
);

export const clearUploadableFormAttachments = createAction(
  '[UploadableFormAttachment/API] Clear UploadableFormAttachments'
);

// CUSTOM
export const createUploadableFormAttachment = createAction(
  '[UploadableFormAttachment/API] Create UploadableFormAttachment',
  props<{ input: UploadableFormAttachmentInput }>()
);

export const editUploadableFormAttachment = createAction(
  '[UploadableFormAttachment/API] Edit UploadableFormAttachment',
  props<{ input: UploadableFormAttachmentInput }>()
);

export const removeUploadableFormAttachment = createAction(
  '[UploadableFormAttachment/API] Remove UploadableFormAttachment',
  props<{ attachmentUniqueId: string, id: string }>()
);

export const getUploadableFormAttachments = createAction(
  '[UploadableFormAttachment/API] get UploadableFormAttachments',
  props<{ formUniqueId?: string; }>()
);

// CITIIZEN
export const citizenGetServiceUploadableFormAttachment = createAction(
  '[UploadableFormAttachment/API] citizen Get UploadableFormAttachment',
  props<{ formUniqueId: string }>()
);

